import { type Vif } from '../vif';
import { type DataToRender } from '../views/BaseVisualization/types';
import { getCategoricalData } from './categorical/categorical-data-manager';
import { getTimeData } from './time/time-data-manager';
import { SoQLType } from 'common/types/soql';

/**
 * Shared entry point into the data manager soql querying code used by most jQuery visualizations.
 */
export function getManagedData(vif: Vif, useTimeDataManager: boolean): Promise<DataToRender> {
  return (useTimeDataManager ? getTimeData(vif) : getCategoricalData(vif)).then((result) => {
    // For generating test fixtures, please just comment out, do not delete.
    // if (!window.socrata.disableDataManagerLogging) {
    //   console.log(JSON.stringify({ visCanUrl: location.href, vif, result }, null, 2));
    // }

    return result;
  });
}

/**
 * The rule `getManagedData`'s callers use to decide time vs. categorical.
 * A calendar_date dimension with a real precision (not `'none'`) goes to the time data manager.
 * Everything else goes to the categorical data manager.
 * Each caller still looks up the dimension's dataTypeName its own way
 * (from column formats, from dataset metadata, from the vif's dimension object),
 * so this only captures the shared boolean rule, not the lookup.
 *
 * Also, flyout vifs are not complete enough to have all of this info.
 * Callers typically force flyout vifs to copy the behavior of the main vif.
 *
 * All of that is why this is just a helper and not baked into the getManagedData function.
 */
export function isTimeSeries(
  dimensionDataTypeName: string | undefined,
  precision: string | undefined | null,
) {
  return dimensionDataTypeName === SoQLType.SoQLFloatingTimestampT && precision !== 'none';
}
